export const formatMinutes = (totalMinutes, lang = null) => {
    if (!lang) {
        lang = localStorage.getItem("language") || "en";
    }


    if (!totalMinutes || isNaN(totalMinutes)) {
        return lang === 'ru' ? '0 ч. 0 мин.' : '0 h 0 min';
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.round(totalMinutes % 60);

    if (lang === 'ru') {
        return `${hours} ч. ${minutes} мин.`;
    }

    return `${hours} h ${minutes} min`;
};
